import {
  AccountThirdPartyServiceOperationCancelledEvent,
  AccountThirdPartyServiceOperationFailEvent,
  AccountThirdPartyServiceOperationStartEvent,
  AccountThirdPartyServiceOperationSuccessEvent,
  GeneralButtonActionEvent,
  Screen,
  ThirdPartyService,
  ThirdPartyServiceCategory,
  ThirdPartyServiceOperation,
  trackEvent,
  UIElementID,
  UIInteractionType,
} from '@otter-ai/telemetry';

export const trackGoogleMain = {
  connectionStart: () => {
    trackEvent(
      AccountThirdPartyServiceOperationStartEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.google,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectionEstablished: () => {
    trackEvent(
      AccountThirdPartyServiceOperationSuccessEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.google,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectionCanceled: () => {
    trackEvent(
      AccountThirdPartyServiceOperationCancelledEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.google,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectionFailed: () => {
    trackEvent(
      AccountThirdPartyServiceOperationFailEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.google,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectGoogle: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsGoogleConnect,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },

  disconnectGoogle: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsGoogleDisconnect,
        UIInteractionType: UIInteractionType.secondaryActivate,
      }),
    );
  },
} as const;

export const trackGoogle = {
  main: trackGoogleMain,
} as const;
